/**
 * Dev Environments API client (P8 stage 1) — the authenticated
 * `/api/cluster/dev-environments` surface behind `/my/dev-environments`.
 *
 * Deliberately built on `clusterAxios`, NOT `utsAxios`: the UTS instance
 * retries 502/503/504 GETs twice with backoff, which would triple the
 * capability probe when the feature flag is off (the blueprint answers a bare
 * 503 `dev_environments_disabled` — a definitive answer, not a hiccup) and
 * would delay the "not enabled" state by ~1.2 s. The plain cluster instance
 * carries the same base URL + Bearer attach without the retry interceptor.
 *
 * All contract logic lives in the pure `utils/dev-env-api-core.js` so it is
 * unit-tested with a fake http; this file only binds it to the real axios.
 */
import clusterAxios from '@/services/cluster-api'
import { createDevEnvironmentsApi } from '@/utils/dev-env-api-core'

export const devEnvironmentsApi = createDevEnvironmentsApi(clusterAxios)

// The APP's connection info (installed-app builder) — loaded on demand when
// the Connection info modal opens; never polled, never touches the workspace.
export const connectionInfo = (id, opts) => devEnvironmentsApi.connectionInfo(id, opts)

// Developer loop Stage A — git inside the workspace (never polled; the
// Changes card loads them on mount, on Refresh and after a push).
export const gitStatus = (id) => devEnvironmentsApi.gitStatus(id)
export const gitDiff = (id, path) => devEnvironmentsApi.gitDiff(id, path)
export const gitCommitPush = (id, body) => devEnvironmentsApi.gitCommitPush(id, body)

// Developer loop Stage B — release status + catalog adopt/finalise. Built from
// GitLab + the cluster + the record, never the workspace; safe to poll.
export const releaseStatus = (id, sha) => devEnvironmentsApi.releaseStatus(id, sha)
export const releaseAdopt = (id, body) => devEnvironmentsApi.releaseAdopt(id, body)
export const releaseFinalize = (id, body) => devEnvironmentsApi.releaseFinalize(id, body)

export default devEnvironmentsApi
